// extracted by mini-css-extract-plugin
export default {"skeletonContainer":"aqRkZ4X97YeLPvsdhpBd"};